export const API = `${process.env.REACT_APP_BACKEND_URL}/api/letter-intel`;
export const pct = (p) => (p == null ? '—' : `${Math.round(p * 100)}%`);
export const OUTCOMES = [
  ['deleted', 'Deleted', 'bg-emerald-500 text-black'],
  ['updated', 'Updated', 'bg-sky-500 text-black'],
  ['verified', 'Verified', 'bg-rose-500 text-white'],
  ['no_response', 'No reply', 'bg-zinc-500 text-white'],
];
